import './predictive-search.scss';
import './search-overlay.scss';

const updateSwatchesEvent = new CustomEvent('swatchesUpdate:needed');

class PredictiveSearch extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[type="search"]');
    this.predictiveSearchResults = this.querySelector('#predictive-search');
    this.loader = this.querySelector('#loader');

    this.input.addEventListener('input', this.debounce((event) => {
      this.onChange(event);
      if(this.input.value !== '') {
        this.loadingSkeleton();
      }
    }, 250).bind(this));
  }

  onChange() {
    const searchTerm = this.input.value.trim();

    if (!searchTerm.length) {
      this.close();
      return;
    }
    this.getSearchResults(searchTerm);
  }

  getSearchResults(searchTerm) {

    fetch(window.Shopify.routes.root + `search/suggest?q=${searchTerm}&section_id=predictive-search&resources[options][fields]=title,tag,product_type,variants.sku,variants.title`)
      .then((response) => {
        if (!response.ok) {
          var error = new Error(response.status);
          this.close();
          throw error;
        }
        return response.text();
      })
      .then((text) => {
        const resultsMarkup = new DOMParser().parseFromString(text, 'text/html').querySelector('#shopify-section-predictive-search').innerHTML;
        this.predictiveSearchResults.innerHTML = resultsMarkup;
        window.dispatchEvent(updateSwatchesEvent);
        this.open();
      })
      .catch((error) => {
        this.close();
        throw error;
      });
  }

  open() {
    this.predictiveSearchResults.style.display = 'block';
  }

  close() {
    this.predictiveSearchResults.style.display = 'none';
  }

  loadingSkeleton(){
    this.loader.classList.add("is-loading");
    setTimeout(() => {
      this.loader.classList.remove("is-loading");
  }, 300);
  }


  debounce(fn, wait) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('predictive-search', PredictiveSearch);
